import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";
import "../styles/GameDetail.css";

function GameDetail() {
  const { appId } = useParams();
  const [game, setGame] = useState(null);
  const [reviews, setReviews] = useState(null); // To store the review data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        // Fetch the game data and review data in one query (using left join)
        const { data, error } = await supabase
          .from("my_steam_games")
          .select("*, reviews(*)")
          .eq("APP_ID", appId)
          .single();

        if (error) throw error;

        // Separate game data and review data
        setGame(data);

        // Check if reviews data exists and if not, set default
        if (data.reviews && Object.keys(data.reviews).length > 0) {
          setReviews(data.reviews);
        } else {
          setReviews(null); // No review data
        }
      } catch (err) {
        console.error("Error fetching game:", err);
        setError("Failed to load game.");
      } finally {
        setLoading(false);
      }
    };

    fetchGameData();
  }, [appId]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!game) return <p>No game found.</p>;

  const headerImg = `https://shared.akamai.steamstatic.com/store_item_assets/steam/apps/${game.APP_ID}/header.jpg`;
  return (
    <div className="game-detail">
      {/* Game header */}
      <img src={headerImg} alt={game.GAME_NAME} className="header-image" />
      <div className="game-info-box">
        <div className="game-stats">
          <h1 className="game-title">{game.GAME_NAME}</h1>

          <div className="stats-section">
            <h2>Game Stats</h2>
            <div className="stat-item">
              <span className="stat-label">Hours Played: </span>
              <span className="stat-value">{game.HOURS_PLAYED.toFixed(2)}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Achievements: </span>
              <span className="stat-value">
                {game.USER_ACH} / {game.GAME_ACH_TOTAL}
              </span>
            </div>
            <div className="progress-bar-container">
              <div
                className="progress-bar-fill"
                style={{
                  width:
                    game.GAME_ACH_TOTAL > 0
                      ? `${(game.USER_ACH / game.GAME_ACH_TOTAL) * 100}%`
                      : "0%",
                }}
              >
                <span className="progress-bar-text">
                  {game.GAME_ACH_TOTAL > 0
                    ? `${((game.USER_ACH / game.GAME_ACH_TOTAL) * 100).toFixed(
                        1
                      )}%`
                    : "0%"}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Review Section */}
        <article className="game-review">
          <h2>My Experience</h2>
          {/* Display Review Text */}
          <div
            className="review-text"
            dangerouslySetInnerHTML={{
              __html:
                reviews && reviews.REVIEW_TEXT
                  ? reviews.REVIEW_TEXT
                  : "Either I haven't gotten to play this yet, or I haven't gotten to write anything about it yet",
            }}
          />

          {/* Display Screenshots */}
          {reviews && (
            <>
              {[...Array(10)].map((_, index) => {
                const screenshotKey = `SCREENSHOT_${index + 1}_URL`;
                if (reviews[screenshotKey]) {
                  return (
                    <img
                      key={index}
                      src={reviews[screenshotKey]}
                      alt={`Screenshot ${index + 1}`}
                      className="game-screenshot"
                    />
                  );
                }
                return null;
              })}
            </>
          )}
        </article>
      </div>
    </div>
  );
}

export default GameDetail;
